import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import blogImg from "../Assest/images/blog/1.jpg";

import "swiper/css";
import "swiper/css/navigation";

/* ===== CATEGORIES ===== */
const categories = [
  "All",
  "Accessories",
  "Contact Lenses",
  "Eyeglasses",
 
];

/* ===== BLOG DATA ===== */
const blogsData = [
  {
    id: 1,
    category: "Sunglasses",
    title: "Add Some Colour To Your Wardrobe With These 5 Sunglasses",
    slug: "add-colour-with-5-sunglasses",
    img: "https://images.unsplash.com/photo-1511499767150-a48a237f0083",
    date: "06 Aug 2021",
    time: "3 min",
    likes: 2,
  },
  {
    id: 2,
    category: "Sunglasses",
    title: "Perfect Blend of Style and Function: Powered Sunglasses",
    slug: "powered-sunglasses-style-function",
    img: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c",
    date: "15 Feb 2020",
    time: "2 min",
    likes: 1,
  },
  {
    id: 3,
    category: "Sunglasses",
    title: "4 Retro Sunglasses for Your Old School Style",
    slug: "retro-sunglasses-old-school",
    img: "https://images.unsplash.com/photo-1517841905240-472988babdf9",
    date: "14 Oct 2022",
    time: "3 min",
    likes: 0,
  },
  {
    id: 4,
    category: "Eyeglasses",
    title: "How To Choose The Right Eyeglasses For Your Face Shape",
    slug: "choose-eyeglasses-face-shape",
    img: "https://images.unsplash.com/photo-1519699047748-de8e457a634e",
    date: "12 Sep 2021",
    time: "4 min",
    likes: 4,
  },
  {
    id: 5,
    category: "Contact Lenses",
    title: "Daily vs Monthly Contact Lenses – What’s Better?",
    slug: "daily-vs-monthly-contact-lenses",
    img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
    date: "10 Jan 2022",
    time: "5 min",
    likes: 3,
  },
];

const BlogPage = () => {
 const blogs = [
  {
    title: "5 Goggles New Style That Your Wardrobe Accessory Must Have",
    date: "13 Oct 2022",
    time: "6 min",
    link: "/blogs/category/sunglasses/5-goggles-new-style-that-your-wardrobe-accessory-must-have",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/5-Goggles_New388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/5-Goggles_New276x256.jpg",
  },
  {
    title: "Seeing Clearly: Deciphering Your Contact Lens Prescription",
    date: "25 Mar 2024",
    time: "2 min",
    tag: "Popular",
    likes: "5",
    link: "/blogs/category/contact-lenses/seeing-clearly-deciphering-your-contact-lens-prescription",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/contact-lens388x425_1.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/contact-lens276x256_1.jpg",
  },
  {
    title: "The Magic of Prescription Glasses: Unveiling the Benefits",
    date: "19 Mar 2024",
    time: "2 min",
    tag: "Popular",
    likes: "1",
    link: "/blogs/category/eyeglasses/the-magic-of-prescription-glasses-unveiling-the-benefits",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/prescription-glasses388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/prescription-glasses276x256.jpg",
  },
  {
    title: "Reflect Your Style With 2024’s Mirrored Sunglasses Trends",
    date: "25 Mar 2024",
    time: "3 min",
    tag: "Featured",
    link: "/blogs/category/sunglasses/reflect-your-style-with-2024s-mirrored-sunglasses-trends",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/mirrored-sunglasses388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/mirrored-sunglasses276x256.jpg",
  },

  {
    title: "5 Goggles New Style That Your Wardrobe Accessory Must Have",
    date: "13 Oct 2022",
    time: "6 min",
    link: "/blogs/category/sunglasses/5-goggles-new-style-that-your-wardrobe-accessory-must-have",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/5-Goggles_New388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/5-Goggles_New276x256.jpg",
  },
  {
    title: "Seeing Clearly: Deciphering Your Contact Lens Prescription",
    date: "25 Mar 2024",
    time: "2 min",
    tag: "Popular",
    likes: "5",
    link: "/blogs/category/contact-lenses/seeing-clearly-deciphering-your-contact-lens-prescription",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/contact-lens388x425_1.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/contact-lens276x256_1.jpg",
  },
  {
    title: "The Magic of Prescription Glasses: Unveiling the Benefits",
    date: "19 Mar 2024",
    time: "2 min",
    tag: "Popular",
    likes: "1",
    link: "/blogs/category/eyeglasses/the-magic-of-prescription-glasses-unveiling-the-benefits",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/prescription-glasses388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/prescription-glasses276x256.jpg",
  },
  {
    title: "Reflect Your Style With 2024’s Mirrored Sunglasses Trends",
    date: "25 Mar 2024",
    time: "3 min",
    tag: "Featured",
    link: "/blogs/category/sunglasses/reflect-your-style-with-2024s-mirrored-sunglasses-trends",
    imgDesktop:
      "https://d3995ea24pmi7m.cloudfront.net/media/wysiwyg/blog/landing-banners/mirrored-sunglasses388x425.jpg",
    imgMobile:
      "https://d3995ea24pmi7m.cloudfront.net/fit-in/276x256/media/wysiwyg/blog/landing-banners/mirrored-sunglasses276x256.jpg",
  },
];

  return (

      <>
   <div className="banner-Wrapper">
      {/* Breadcrumb */}
      <div className="container my-3">
        <ol className="breadcrumb common_breadcrumb__DlZdr">
          <li className="breadcrumb-item common_breadcrumb-item__zIN4U">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item common_breadcrumb-item__zIN4U">
            <span className="breadcrumb-item active">Blogs</span>
          </li>
        </ol>
      </div>

      {/* Slider */}
      {/* <Swiper
        modules={[Navigation]}
        spaceBetween={30}
        slidesPerView={7}
        navigation
        loop
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
        }}
        className="swiper-container blogSlider"
      >
        {blogs.map((blog, index) => (
          <SwiperSlide key={index} className="changed">
            <a className="cont" href={blog.link}>
              <div className="img-wrap">
                <picture>
                  <source
                    media="(max-width: 540px)"
                    srcSet={blog.imgMobile}
                  />
                  <img
                    src={blog.imgDesktop}
                    alt="images"
                    loading="lazy"
                    width="425"
                    height="388"
                  />
                </picture>

                {blog.tag && (
                  <div className="articleTags">
                    <button
                      type="button"
                      className={`tags ${blog.tag.toLowerCase()}`}
                    >
                      {blog.tag}
                    </button>
                  </div>
                )}
              </div>

              <div className="caption">
                <h2>{blog.title}</h2>

                <div className="common_articleFooter__b_1cj">
                  <span className="common_date__CA1cm">{blog.date}</span>
                  <span className="common_time__4MNK3">{blog.time}</span>
                  <button
                    type="button"
                    className="common_like__2fURi blogDetails_like__QJrBI"
                  >
                    {blog.likes || ""}
                  </button>
                </div>
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper> */}

     
    </div>

     <div className="container">

      {/* BLOG FILTER */}
      <section className="common_pb-40__SZLoS">
        <div className="common_categoryButton__Dvwc5">
          <div className="common_homeBlogFilter__iTJpe">
            <h1 className="common_mediumTitle__OzGx_ common_homeTitle__o_KHL">
              Blogs
            </h1>

            <div className="common_menuButton__gnJ6T">
              <button className="common_outlineButton__YbALO common_active__kTZj4">All</button>
              <button className="common_outlineButton__YbALO">Accessories</button>
              <button className="common_outlineButton__YbALO">Contact Lenses</button>
              <button className="common_outlineButton__YbALO">Eyeglasses</button>
              <button className="common_outlineButton__YbALO">Titan Vision Care</button>
             
            </div>
          </div>
        </div>

        {/* BLOG GRID */}
        <div className="row">
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
             <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card blog-card">
                 <div className="card-body">
                    <img src={blogImg} alt="Blog" />
                    <div class="blog-card-content">

                      <ul class="common_categoryTag__Si6oD"><li class="common_tag___Meyd"><a href="/blogs/category/accessories">Accessories</a></li></ul>
                        <a className="blog-link" href="javascript:void(0);">Contact Lens Colour Trends: Choosing the Perfect Hue for 2024</a>
                        
                    </div>

                    <div class="common_articleFooter__b_1cj"><span class="common_date__CA1cm">15 Oct 2022</span><span class="common_time__4MNK3">3 min </span><button type="button" id="like_a_blog_button_247" class="common_like__2fURi  blogDetails_like__QJrBI " fdprocessedid="rv6nt8">3</button></div>
                 </div>
              </div>
            </div>
        </div>

        <div className="common_viewAllBlog___qUN7">
          <a className="common_viewMore__zv1r9" href="/blogs/category/all">
            View all blogs
          </a>
        </div>
      </section>

    </div>

  </>
  );
};

export default BlogPage;
